import { inject, Injectable } from '@angular/core';
import type { AppContext, AppId } from './app-context.types';
import { APP_CONTEXT } from './app-context.const';

@Injectable({ providedIn: 'root' })
export class AppContextService {
  private readonly context: AppContext = inject(APP_CONTEXT);

  get id(): AppId {
    return this.context.id;
  }

  get apiUrl(): string {
    return this.context.apiUrl;
  }

  get apiPrefix(): string {
    return this.context.apiPrefix;
  }

  buildEndpoint(path: string): string {
    return `${this.stripTrailingSlash(this.context.apiUrl)}${this.ensureLeadingSlash(this.context.apiPrefix)}${this.ensureLeadingSlash(path)}`;
  }

  private stripTrailingSlash(value: string): string {
    return value.endsWith('/') ? value.slice(0, -1) : value;
  }

  private ensureLeadingSlash(value: string): string {
    if (value === '') return '';
    return value.startsWith('/') ? value : `/${value}`;
  }
}
